export default "__VITE_ASSET__DlexArOq__"